import {RHFMultilingualField} from '@/shared/components/forms/theme-elements/form/RHFMultilingualField';
import {Grid, Typography} from '@mui/material';
import {useFormContext} from 'react-hook-form';
import {Countries} from './Countries';

export const HeroSection = () => {
  const {
    watch,
    formState: {errors},
  } = useFormContext();
  const values = watch('heroSection') || {};
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Button Text
        </Typography>
        <RHFMultilingualField name={'heroSection.button.text'} />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Packages Text
        </Typography>
        <RHFMultilingualField name={'heroSection.packages.text'} />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Countries
        </Typography>
        <Countries
          name={'heroSection.countries'}
          values={values?.countries}
          errors={errors?.heroSection?.countries}
        />
      </Grid>
    </Grid>
  );
};
